(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
  var REDUCED_MOTION_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TAP_MAX_MOVE = 12;
  var TAP_MAX_DURATION = 320;

  function parseNumber(value, fallback) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function padIndex(value, total) {
    var width = Math.max(String(total).length, 2);
    var str = String(value);
    while (str.length < width) str = '0' + str;
    return str;
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-nr-interview-viewport]');
    var track = root.querySelector('[data-nr-interview-track]');
    var pagerLabel = root.querySelector('[data-nr-interview-pager-label]');
    var pagerPrev = root.querySelector('[data-nr-interview-pager-prev]');
    var pagerNext = root.querySelector('[data-nr-interview-pager-next]');
    if (!viewport || !track) return;

    var baseSpeed = parseNumber(root.getAttribute('data-base-speed'), 6) / 10;
    var boostMultiplier = parseNumber(root.getAttribute('data-boost-multiplier'), 3);
    var edgeZonePercent = parseNumber(root.getAttribute('data-edge-zone'), 20);
    var resumeDelay = parseNumber(root.getAttribute('data-resume-delay'), 1000);
    var slideCount = parseNumber(root.getAttribute('data-slide-count'), 0);
    var slideLink = root.getAttribute('data-slide-link') || '';
    var confirmDesktop = root.getAttribute('data-confirm-desktop') === 'true';

    var isMobile = MOBILE_MQ.matches;
    var reducedMotion = REDUCED_MOTION_MQ.matches;
    var visible = true;
    var paused = false;
    var pointerZone = 0;
    var resumeTimer = null;
    var rafId = null;
    var position = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var touchMoved = false;
    var openConfirmLink = null;

    function setMode() {
      isMobile = MOBILE_MQ.matches;
      reducedMotion = REDUCED_MOTION_MQ.matches;
      root.classList.toggle('nr-interview-highlight--desktop', !isMobile && !reducedMotion);
      root.classList.toggle('nr-interview-highlight--mobile', isMobile);
      root.classList.toggle('nr-interview-highlight--confirm-desktop', confirmDesktop);
      closeConfirm();
      syncPositionFromViewport();
      updatePagerLabel();
    }

    function needsConfirm() {
      return isMobile || confirmDesktop;
    }

    function getMainSlides() {
      return track.querySelectorAll(':scope > .nr-interview-highlight__slide');
    }

    function getLoopWidth() {
      if (isMobile) return track.scrollWidth;
      var loop = track.querySelector('[data-nr-interview-track-loop]');
      if (!loop) return track.scrollWidth / 2;
      var firstLoopSlide = loop.querySelector('.nr-interview-highlight__slide');
      if (!firstLoopSlide) return track.scrollWidth / 2;
      return firstLoopSlide.offsetLeft;
    }

    function getCurrentIndex() {
      var slides = getMainSlides();
      if (!slides.length || !slideCount) return 0;
      var loopWidth = getLoopWidth();
      var normalized = !isMobile && loopWidth > 0 ? position % loopWidth : position;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var dist = Math.abs(normalized - slides[i].offsetLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      if (isMobile) return Math.min(best, slideCount - 1);
      return best;
    }

    function wrapPosition() {
      if (isMobile) return;
      var half = getLoopWidth();
      if (half <= 0) return;
      if (position >= half) position -= half;
      else if (position < 0) position += half;
    }

    function syncPositionFromViewport() {
      position = viewport.scrollLeft;
      wrapPosition();
    }

    function updatePagerLabel() {
      if (!pagerLabel || !slideCount) return;
      var current = getCurrentIndex() + 1;
      pagerLabel.textContent = padIndex(current, slideCount) + ' / ' + padIndex(slideCount, slideCount);
    }

    function getSpeed() {
      if (isMobile || paused || reducedMotion || !visible || openConfirmLink) return 0;
      var speed = baseSpeed;
      if (pointerZone !== 0) speed = baseSpeed * boostMultiplier * pointerZone;
      return speed;
    }

    function tick() {
      var speed = getSpeed();
      if (speed !== 0) {
        position += speed;
        wrapPosition();
        viewport.scrollLeft = position;
        updatePagerLabel();
      }
      rafId = window.requestAnimationFrame(tick);
    }

    function pauseScroll() {
      paused = true;
      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume() {
      if (isMobile || openConfirmLink) return;
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        paused = false;
        syncPositionFromViewport();
        resumeTimer = null;
      }, resumeDelay);
    }

    function scrollToIndex(index) {
      var slides = getMainSlides();
      if (!slides.length || !slideCount) return;
      closeConfirm();
      pauseScroll();
      var targetIndex = index;
      if (targetIndex < 0) targetIndex = slideCount - 1;
      if (targetIndex >= slideCount) targetIndex = 0;
      if (isMobile) {
        position = slides[targetIndex].offsetLeft;
        viewport.scrollTo({ left: position, behavior: 'smooth' });
      } else {
        syncPositionFromViewport();
        var current = getCurrentIndex();
        var delta = targetIndex - current;
        if (delta > slideCount / 2) delta -= slideCount;
        if (delta < -slideCount / 2) delta += slideCount;
        position += slides[(current + delta + slideCount) % slideCount].offsetLeft - slides[current].offsetLeft;
        wrapPosition();
        viewport.scrollLeft = position;
      }
      updatePagerLabel();
      scheduleResume();
    }

    function scrollBySlide(direction) {
      scrollToIndex(getCurrentIndex() + direction);
    }

    function closeConfirm() {
      root.querySelectorAll('.nr-interview-highlight__link.is-confirm-open').forEach(function (link) {
        link.classList.remove('is-confirm-open');
        var c = link.querySelector('.nr-interview-highlight__confirm');
        if (c) c.hidden = true;
      });
      openConfirmLink = null;
      if (!isMobile && paused) scheduleResume();
    }

    function openConfirm(link) {
      if (!link || !slideLink) return;
      closeConfirm();
      pauseScroll();
      openConfirmLink = link;
      link.classList.add('is-confirm-open');
      var confirm = link.querySelector('.nr-interview-highlight__confirm');
      if (confirm) confirm.hidden = false;
    }

    function navigateToSlideLink() {
      if (!slideLink) return;
      window.location.href = slideLink;
    }

    function handleSlideActivate(link) {
      if (!slideLink || !link) return;
      if (needsConfirm()) {
        openConfirm(link);
        return;
      }
      pauseScroll();
      navigateToSlideLink();
    }

    function handleTrackClick(event) {
      var link = event.target.closest('[data-nr-interview-slide-link]');
      if (!link || !track.contains(link)) return;
      if (event.target.closest('.nr-interview-highlight__confirm-btn')) return;
      event.preventDefault();
      handleSlideActivate(link);
    }

    function handleConfirmClick(event) {
      var btn = event.target.closest('.nr-interview-highlight__confirm-btn');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      navigateToSlideLink();
    }

    function handleTouchStart(event) {
      if (!event.touches.length) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchStartTime = Date.now();
      touchMoved = false;
    }

    function handleTouchMove(event) {
      if (!event.touches.length) return;
      var dx = Math.abs(event.touches[0].clientX - touchStartX);
      var dy = Math.abs(event.touches[0].clientY - touchStartY);
      if (dx > TAP_MAX_MOVE || dy > TAP_MAX_MOVE) {
        touchMoved = true;
        closeConfirm();
      }
    }

    function handleTouchEnd(event) {
      if (touchMoved) return;
      if (Date.now() - touchStartTime > TAP_MAX_DURATION) return;
      var link = event.target.closest('[data-nr-interview-slide-link]');
      if (!link || !track.contains(link)) return;
      if (event.target.closest('.nr-interview-highlight__confirm-btn')) return;
      event.preventDefault();
      handleSlideActivate(link);
    }

    function handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var link = event.target.closest('[data-nr-interview-slide-link]');
      if (!link || !track.contains(link)) return;
      event.preventDefault();
      handleSlideActivate(link);
    }

    function handleOutsidePointer(event) {
      if (!openConfirmLink) return;
      if (root.contains(event.target)) return;
      closeConfirm();
    }

    function handlePointerMove(event) {
      if (isMobile || reducedMotion) return;
      var rect = viewport.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var edge = rect.width * (edgeZonePercent / 100);
      if (x < edge) pointerZone = -1;
      else if (x > rect.width - edge) pointerZone = 1;
      else pointerZone = 0;
    }

    function handlePointerLeave() {
      pointerZone = 0;
    }

    function handleViewportScroll() {
      if (isMobile) {
        position = viewport.scrollLeft;
        updatePagerLabel();
      }
    }

    if (pagerPrev) pagerPrev.addEventListener('click', function (e) { e.preventDefault(); scrollBySlide(-1); });
    if (pagerNext) pagerNext.addEventListener('click', function (e) { e.preventDefault(); scrollBySlide(1); });

    track.addEventListener('click', handleTrackClick);
    track.addEventListener('click', handleConfirmClick);
    track.addEventListener('keydown', handleKeydown);
    viewport.addEventListener('touchstart', handleTouchStart, { passive: true });
    viewport.addEventListener('touchmove', handleTouchMove, { passive: true });
    viewport.addEventListener('touchend', handleTouchEnd);
    viewport.addEventListener('touchcancel', handleTouchEnd);
    viewport.addEventListener('scroll', handleViewportScroll, { passive: true });
    document.addEventListener('pointerdown', handleOutsidePointer);
    root.addEventListener('mousemove', handlePointerMove);
    root.addEventListener('mouseleave', handlePointerLeave);
    MOBILE_MQ.addEventListener('change', setMode);
    REDUCED_MOTION_MQ.addEventListener('change', setMode);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0] && entries[0].isIntersecting;
      }, { threshold: 0 }).observe(root);
    }

    setMode();
    updatePagerLabel();
    if (!reducedMotion) rafId = window.requestAnimationFrame(tick);

    window.addEventListener('pagehide', function () {
      if (rafId) window.cancelAnimationFrame(rafId);
      if (resumeTimer) window.clearTimeout(resumeTimer);
      document.removeEventListener('pointerdown', handleOutsidePointer);
    }, { once: true });
  }

  function init() {
    document.querySelectorAll('[data-nr-interview-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();